import { usePopup } from 'hooks/usePopup'
import { useRef, useState } from 'react'
import { separationOrderService } from 'services/separationOrderService'

import {
  ButtonCancel,
  ButtonConfirm,
  Container,
  ContainerButtons,
  InfoCostumer,
  Modal,
  TextConfirmRelease,
  Title,
} from './styles'
import { Loading } from 'pages/Admin/Breaks/styles'
import { IModalOrderCanceled, ModalOrderCanceled } from '../ModalOrderCanceled'
import { OrderDetailsResponse } from 'interfaces/IOrderDetails'
import { invoiceService } from 'services/invoiceService'

interface IModalConfirmOrderLoad {
  open: boolean
  handleClose: () => void
  order: OrderDetailsResponse
  pollingInvoice: (isError: boolean, isRefresh: boolean) => Promise<void>
}

export const ModalConfirmLoad = ({
  handleClose,
  order,
  pollingInvoice,
  open,
}: IModalConfirmOrderLoad) => {
  const { addPopup } = usePopup()
  const [isLoading, setIsLoading] = useState(false)
  const modalOrderCanceledRef = useRef<IModalOrderCanceled>(null)

  const handleConfirm = async () => {
    try {
      setIsLoading(true)
      await invoiceService.patchReleaseWithoutInvoice(
        { releaseWithoutInvoice: true },
        order.order_id,
      )
      await pollingInvoice(false, true)
      addPopup({
        type: 'success',
        title: 'Pedido liberado com sucesso',
      })
      handleClose()
    } catch (error: any) {
      if (error?.message === 'This order has been canceled') {
        modalOrderCanceledRef.current?.onOpen()
        return
      }
      addPopup({
        type: 'error',
        title: 'Ocorreu um erro',
        description: error?.message || error,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Modal open={open}>
        <Container>
          <Loading loading={isLoading} />
          <Title>Liberar pedido</Title>
          <InfoCostumer>
            <p>
              Cliente: <strong>{order.client_name_or_trade}</strong>
            </p>
            <p>
              N° Pedido: <strong>#{order.order_id}</strong>
            </p>
          </InfoCostumer>
          <TextConfirmRelease>
            Confirmar a liberação desse pedido sem nota fiscal?
          </TextConfirmRelease>
          <ContainerButtons>
            <ButtonCancel onClick={handleClose} disabled={isLoading}>
              Cancelar
            </ButtonCancel>
            <ButtonConfirm onClick={handleConfirm} disabled={isLoading}>
              Confirmar
            </ButtonConfirm>
          </ContainerButtons>
        </Container>
      </Modal>
      <ModalOrderCanceled
        orderId={order.order_id}
        clientName={order.client_name_or_trade}
        callback={handleClose}
        ref={modalOrderCanceledRef}
      />
    </>
  )
}
